"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(width, stokeWidth, unit) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccDonutStyle = (0, _react.useMemo)(function () {
    var ccDonut = (0, _css.css)({
      position: 'relative',
      top: 0,
      left: 0,
      width: pxToRem(width),
      height: pxToRem(width)
    });
    var ccDonutBasicCircle = function ccDonutBasicCircle() {
      return {
        cx: width / 2,
        cy: width / 2,
        strokeWidth: stokeWidth,
        fill: 'none'
      };
    };
    var ccDonutBackgroundCircle = (0, _css.css)(_objectSpread(_objectSpread({}, ccDonutBasicCircle()), {}, {
      stroke: themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light
    }));
    var ccDonutValueCircle = (0, _css.css)(_objectSpread(_objectSpread({}, ccDonutBasicCircle()), {}, {
      stroke: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
      transform: "rotate(-90deg)",
      transformOrigin: 'center'
    }));
    var ccDonutText = (0, _css.css)({
      position: 'absolute',
      width: '100%',
      top: '50%',
      transform: 'translate(0, -50%)',
      textAlign: 'center',
      fontFamily: fontFamily,
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
      left: unit && unit.length > 0 ? pxToRem(unit.length * 2) : 0
    });
    var ccDonutValue = (0, _css.css)({
      fontSize: pxToRem(Math.floor(width / 3))
    });
    var ccDonutUnit = (0, _css.css)({
      fontSize: pxToRem(Math.floor(width / 5.5))
    });
    return {
      ccDonut: ccDonut,
      ccDonutBackgroundCircle: ccDonutBackgroundCircle,
      ccDonutValueCircle: ccDonutValueCircle,
      ccDonutText: ccDonutText,
      ccDonutValue: ccDonutValue,
      ccDonutUnit: ccDonutUnit
    };
  }, [width, stokeWidth, unit, fontFamily, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, pxToRem]);
  return {
    'cc-Donut': ccDonutStyle.ccDonut,
    'cc-Donut__background-circle': ccDonutStyle.ccDonutBackgroundCircle,
    'cc-Donut__value-circle': ccDonutStyle.ccDonutValueCircle,
    'cc-Donut__text': ccDonutStyle.ccDonutText,
    'cc-Donut__text__value': ccDonutStyle.ccDonutValue,
    'cc-Donut__text__unit': ccDonutStyle.ccDonutUnit
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;